import Dashboard from './dashboard'
// import Admin from './admin'
import Builder from './builder'
import Slicer from './slicer'
import Preset from './preset'
import Survey from './survey'
import Scorecard from './scorecard'

export {
    // Admin,
    Dashboard,
    Builder,
    Slicer,
    Preset,
    Scorecard,
    Survey
}



// WEBPACK FOOTER //
// ./src/new_containers/index.js